import { gql } from '@apollo/client';
import { GqlAcceptInviteResponse, GqlInvitationFragment } from '../fragments/invitation';

export interface Input {
  token: string;
}

export interface Data {
  acceptInvite: GqlAcceptInviteResponse;
}

export const MUTATION = gql`
  mutation AcceptInvite($token: String!) {
    acceptInvite(token: $token) {
      invitation {
        ...InvitationFields
      }
      result
      hasOrgAccess
    }
  }
  ${GqlInvitationFragment}
`;
